import { render, staticRenderFns } from "./OwnerTable.vue?vue&type=template&id=94a32888&scoped=true"
import script from "./OwnerTable.vue?vue&type=script&lang=js"
export * from "./OwnerTable.vue?vue&type=script&lang=js"
import style0 from "./OwnerTable.vue?vue&type=style&index=0&id=94a32888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a32888",
  null
  
)

export default component.exports